import{defineMessages}from'react-intl';

export default defineMessages({
title_default:{
id:'confirmation_modal.title_default',
defaultMessage:'Are you sure?'},

button_cancel:{
id:'confirmation_modal.button_cancel',
defaultMessage:'Cancel'},

button_confirm:{
id:'confirmation_modal.button_confirm',
defaultMessage:'Confirm'}});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9wYWdlcy9Qb3BvdXRDb25maXJtYXRpb25Nb2RhbC9Qb3BvdXRDb25maXJtYXRpb25Nb2RhbC5tZXNzYWdlcy5qcyJdLCJuYW1lcyI6WyJkZWZpbmVNZXNzYWdlcyIsInRpdGxlX2RlZmF1bHQiLCJpZCIsImRlZmF1bHRNZXNzYWdlIiwiYnV0dG9uX2NhbmNlbCIsImJ1dHRvbl9jb25maXJtIl0sIm1hcHBpbmdzIjoiQUFBQSxPQUFTQSxjQUFULEtBQStCLFlBQS9COztBQUVBLGNBQWVBLGdCQUFlO0FBQzVCQyxjQUFlO0FBQ2JDLEdBQUksa0NBRFM7QUFFYkMsZUFBZ0IsZUFGSCxDQURhOztBQUs1QkMsY0FBZTtBQUNiRixHQUFJLGtDQURTO0FBRWJDLGVBQWdCLFFBRkgsQ0FMYTs7QUFTNUJFLGVBQWdCO0FBQ2RILEdBQUksbUNBRFU7QUFFZEMsZUFBZ0IsU0FGRixDQVRZLENBQWYsQ0FBZiIsImZpbGUiOiJQb3BvdXRDb25maXJtYXRpb25Nb2RhbC5tZXNzYWdlcy5qcyIsInNvdXJjZVJvb3QiOiIvYXBwIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgZGVmaW5lTWVzc2FnZXMgfSBmcm9tICdyZWFjdC1pbnRsJztcblxuZXhwb3J0IGRlZmF1bHQgZGVmaW5lTWVzc2FnZXMoe1xuICB0aXRsZV9kZWZhdWx0OiB7XG4gICAgaWQ6ICdjb25maXJtYXRpb25fbW9kYWwudGl0bGVfZGVmYXVsdCcsXG4gICAgZGVmYXVsdE1lc3NhZ2U6ICdBcmUgeW91IHN1cmU/JyxcbiAgfSxcbiAgYnV0dG9uX2NhbmNlbDoge1xuICAgIGlkOiAnY29uZmlybWF0aW9uX21vZGFsLmJ1dHRvbl9jYW5jZWwnLFxuICAgIGRlZmF1bHRNZXNzYWdlOiAnQ2FuY2VsJyxcbiAgfSxcbiAgYnV0dG9uX2NvbmZpcm06IHtcbiAgICBpZDogJ2NvbmZpcm1hdGlvbl9tb2RhbC5idXR0b25fY29uZmlybScsXG4gICAgZGVmYXVsdE1lc3NhZ2U6ICdDb25maXJtJyxcbiAgfSxcbn0pO1xuIl19


//////////////////
// WEBPACK FOOTER
// ./src/pages/PopoutConfirmationModal/PopoutConfirmationModal.messages.js
// module id = 2177
// module chunks = 0